import { useState, useEffect } from 'react';
import DropDownItem from './DropDownItem';
import styles from './DropDown.module.scss';
import ExpandMoreRight from '../Svg/ExpandMoreRight';
import cn from 'classnames';

export const DropDown = props => {
  const { data, onChange, handleCloseMainDropDown, currentCategoryID, isDropdownShown, multiple } = props;
  const [subIndex, changeSubIndex] = useState([]);
  const [iconActive, changeIconActive] = useState(false);

  useEffect(() => {
    changeSubIndex([]);
  }, [isDropdownShown]);

  const handleOpenSubItems = i => {
    if (subIndex.includes(i)) {
      subIndex.splice(subIndex.indexOf(i), 1);
    } else {
      changeSubIndex([...subIndex, i]);
    }
    changeIconActive(!iconActive);
  };
  const isEqualID = value => currentCategoryID.includes(value);
  const handleSetActive = value => {
    multiple ? handleMultipleToggle(value) : onChange(value);
    handleCloseMainDropDown();
  };
  const handleMultipleToggle = value => {
    if (Array.isArray(currentCategoryID) && isEqualID(value)) {
      const dublicateIndex = currentCategoryID.findIndex(el => el === value);
      currentCategoryID.splice(dublicateIndex, 1);
      return onChange(currentCategoryID, null);
    }
    return onChange(value);
  };

  return (
    <div className={styles.dropdown}>
      {data.map((item, index) => {
        const showSubItemsCondition = subIndex.includes(index) && item.children?.length !== 0;
        const mainClass = showSubItemsCondition
          ? cn(styles.mainContainer, styles.activeContainer)
          : styles.mainContainer;
        const randomKey = key => `${Math.random()} ${key}`;

        return (
          <div key={`${randomKey(item.label)}${index}`} className={styles.dropDownItem}>
            <div
              className={
                item.children && item.children.length === 0 ? cn(mainClass, styles.singleContainer) : mainClass
              }
            >
              <DropDownItem
                isActive={isEqualID(item.value)}
                label={item.label}
                value={item.value}
                onTextClick={() => handleSetActive(item.value)}
              />

              {item.children && item.children.length !== 0 && (
                <div className={styles.buttonContainer} onClick={() => handleOpenSubItems(index)}>
                  <ExpandMoreRight />
                </div>
              )}
            </div>
            {showSubItemsCondition && (
              <div className={styles.subMenu}>
                {item.children?.map(subItem => (
                  <DropDownItem
                    label={subItem.label}
                    key={`${index}${randomKey(subItem.label)}`}
                    value={subItem.value}
                    isActive={isEqualID(subItem.value)}
                    onTextClick={() => handleSetActive(subItem.value)}
                  />
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
